export const SHIFT_OPTION_FIRST = 'First';
export const SHIFT_OPTION_SECOND = 'Second';
export const SHIFT_OPTION_THIRD = 'Third';
export const SHIFT_OPTION_SPLIT = 'Split';
export const SHIFT_OPTION_WEEKEND = 'Weekend';
export const SHIFT_OPTION_FIXED = 'Fixed';
export const SHIFT_OPTION_ROTATING = 'Rotating';
export const SHIFT_OPTION_ON_CALL = 'On-Call';

export const SHIFT_OPTIONS = [
  SHIFT_OPTION_FIRST,
  SHIFT_OPTION_SECOND,
  SHIFT_OPTION_THIRD,
  SHIFT_OPTION_SPLIT,
  SHIFT_OPTION_WEEKEND,
  SHIFT_OPTION_FIXED,
  SHIFT_OPTION_ROTATING,
  SHIFT_OPTION_ON_CALL,
];

export const SCHEDULE_OPTION_FULL = 'Full-Time';
export const SCHEDULE_OPTION_PART = 'Part-Time';
export const SCHEDULE_OPTION_FLEX = 'Flexible Schedule';
export const SCHEDULE_OPTION_ALT = 'Alternative Schedule';

export const SCHEDULE_OPTIONS = [
  SCHEDULE_OPTION_FULL,
  SCHEDULE_OPTION_PART,
  SCHEDULE_OPTION_FLEX,
  SCHEDULE_OPTION_ALT,
];

export const OPTION_YES = 'Yes';
export const OPTION_NO = 'No';

export const YES_NO_OPTIONS = [OPTION_YES, OPTION_NO];

export const OPTION_NONE = 'None';

export const MIN_CLEARANCE_OPTION_CONFIDENTIAL = 'Confidential';
export const MIN_CLEARANCE_OPTION_SECRET = 'Secret';
export const MIN_CLEARANCE_OPTION_TOP_SECRET = 'Top Secret';
export const MIN_CLEARANCE_OPTION_TOP_SECRET_SCI = 'Top Secret SCI';

export const MIN_CLEARANCE_OPTIONS = [
  OPTION_NONE,
  MIN_CLEARANCE_OPTION_CONFIDENTIAL,
  MIN_CLEARANCE_OPTION_SECRET,
  MIN_CLEARANCE_OPTION_TOP_SECRET,
  MIN_CLEARANCE_OPTION_TOP_SECRET_SCI,
];

export const POLYGRAPH_TYPE_OPTION_CI = 'CI Polygraph';
export const POLYGRAPH_TYPE_OPTION_LIFESTYLE = 'Lifestyle Polygraph';

export const POLYGRAPH_TYPE_OPTIONS = [
  OPTION_NONE,
  POLYGRAPH_TYPE_OPTION_CI,
  POLYGRAPH_TYPE_OPTION_LIFESTYLE,
];

export const EDUCATION_REQUIRED_OPTION_HIGH_SCHOOL = 'High School';
export const EDUCATION_REQUIRED_OPTION_PRO_CERT = 'Professional Certificate';
export const EDUCATION_REQUIRED_OPTION_ASSOCIATE = 'Associate Degree';
export const EDUCATION_REQUIRED_OPTION_BACHELOR = 'Bachelor Degree';
export const EDUCATION_REQUIRED_OPTION_MASTER = 'Master Degree';
export const EDUCATION_REQUIRED_OPTION_DOC = 'Doctoral Degree';

export const EDUCATION_REQUIRED_OPTIONS = [
  OPTION_NONE,
  EDUCATION_REQUIRED_OPTION_HIGH_SCHOOL,
  EDUCATION_REQUIRED_OPTION_PRO_CERT,
  EDUCATION_REQUIRED_OPTION_ASSOCIATE,
  EDUCATION_REQUIRED_OPTION_BACHELOR,
  EDUCATION_REQUIRED_OPTION_MASTER,
  EDUCATION_REQUIRED_OPTION_DOC,
];

export const FILLED_CLOSED_OPTION_FILLED = 'Filled';
export const FILLED_CLOSED_OPTION_CLOSED = 'Closed';

export const FILLED_CLOSED_OPTIONS = [
  FILLED_CLOSED_OPTION_FILLED,
  FILLED_CLOSED_OPTION_CLOSED,
];

export const IS_OPEN_TRUE = 'TRUE';
export const IS_OPEN_FALSE = 'FALSE';
